import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const fetchSalesForecastByDealers = (salesType, year, month, clientId) => {
  const salesTypeFilter = salesType ? `&salesType=${salesType}` : '';
  const yearFilter = year ? `&year=${year}` : '';
  const monthFilter = month ? `&month=${month}` : '';
  const clientFilter = clientId ? `&clientId=${clientId}` : '';
  
  return apiActionCreator({
    'endpoint': `/vehicles/forecast-by-dealers/sales?${salesTypeFilter}${yearFilter}${monthFilter}${clientFilter}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_SALE_FORECAST_BY_DEALERS,
      ActionTypes.FETCHED_SALE_FORECAST_BY_DEALERS,
      [
        ActionTypes.FETCHED_SALE_FORECAST_BY_DEALERS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchSaleForecast = (salesType, clientId, weeks) => apiActionCreator({
  'endpoint': `/vehicles/forecast/sales${getUrlParameters({clientId, weeks, salesType})}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_SALE_FORECAST,
    ActionTypes.FETCHED_SALE_FORECAST,
    [
      ActionTypes.FETCHED_SALE_FORECAST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearSaleForecast = () => ({
  'type': ActionTypes.CLEAR_SALE_FORECAST_LIST,
});

export const saveSaleForecastData = (dataToSave) => apiActionCreator({
  'endpoint': '/vehicles/forecast/sales',
  'authenticated': true,
  'types': [
    ActionTypes.SAVING_SALE_FORECAST_DATA,
    [
      {
        'type': ActionTypes.SAVED_SALE_FORECAST_DATA,
        'payload': dataToSave,
      },
      MessageActions.addMessageBoxInfo('La proyeción de ventas ha sido guardada satisfactoriamente'),
    ],
    [
      ActionTypes.SAVED_SALE_FORECAST_DATA_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': dataToSave,
});
